import { OBJECT_COORDINATES } from '../../../filterQueryFormat/UnifiedEventPropertyTypes';
import { Map as ImmutableMap } from 'immutable';
import { getPropertyDefinitionOverrideForUnifiedEventProperty } from '../unifiedEventPropertyDefinitionOverrides';
import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import { getMetadataValue } from '../../../utils/frameworkBuilder';
export const getDSFieldRecordFromFrameworkBuilderMetadata = (name, metadata) => {
  const {
    description,
    label,
    numberDisplayHint,
    targetObjectType,
    type
  } = metadata;
  return DSFieldRecord({
    description: getMetadataValue(description),
    label: getMetadataValue(label) || name,
    name,
    numberDisplayHint: getMetadataValue(numberDisplayHint),
    referencedObjectType: getMetadataValue(targetObjectType),
    type: getMetadataValue(type)
  });
};
export const formatUnifiedEventProperties = (response, assetFamily) => {
  const [frameworkBuilderUnifiedEventProperties, propertyDefinitions] = response;
  const formatted = Object.entries(frameworkBuilderUnifiedEventProperties).reduce((acc, [key, {
    metadata
  }]) => {
    var _metadata$targetObjec;
    const type = metadata.type.value;
    const propertyDefinition = propertyDefinitions.find(({
      property
    }) => key === property.name);
    if (type !== OBJECT_COORDINATES && propertyDefinition) {
      // if we are using the property definition, we might need to apply a override to get properties to appear as customer expect
      // generally this is to force number or string properties to appear as enumerations
      const propertyDefinitionOverride = getPropertyDefinitionOverrideForUnifiedEventProperty(assetFamily, propertyDefinition.property.name);
      const property = propertyDefinitionOverride ? Object.assign({}, propertyDefinition.property, propertyDefinitionOverride) : propertyDefinition.property;
      return acc.set(key, DSFieldRecord.fromJS(property));
    }
    if (type === OBJECT_COORDINATES && (_metadata$targetObjec = metadata.targetObjectType) !== null && _metadata$targetObjec !== void 0 && _metadata$targetObjec.value) {
      return acc.set(key, getDSFieldRecordFromFrameworkBuilderMetadata(key, metadata));
    }
    return acc;
  }, ImmutableMap());
  return formatted;
};